import { supabase } from '@/lib/supabase';
import { API_BASE_URL } from '@/lib/apiBaseUrl';

/**
 * POST a referral / affiliate attribution with the caller's Supabase JWT.
 *
 * The server derives the referee's email + id from the verified token (not the
 * request body), so attributions cannot be forged for arbitrary accounts. Only
 * the referrer's code travels in the body. Fire-and-forget safe: never throws,
 * returns a plain result object the caller can branch on ({ ok } / { error }).
 *
 * @param {string} path  e.g. '/api/referral/attribute' or '/api/affiliate/attribute'
 * @param {object} body  code payload, e.g. { refCode } or { affiliateCode }
 * @returns {Promise<object>} parsed JSON, or { ok:false, error } on no session / failure
 */
export async function postAttribution(path, body) {
  try {
    const { data } = await supabase.auth.getSession();
    const token = data?.session?.access_token;
    if (!token) return { ok: false, error: 'no_session' };
    const resp = await fetch(`${API_BASE_URL}${path}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });
    return await resp.json().catch(() => ({}));
  } catch (err) {
    return { ok: false, error: String(err) };
  }
}
